import { createStore} from 'redux';

import cartReducer from '../reducers/cartReducer'

  const store2 = createStore(
    cartReducer, 
  )


export default  store2
